const categoryColors = {
  'Errors': '#dc3545',            // crvena
  'Contrast Errors': '#0d6efd',   // plava
  'Alerts': '#ffc107',            // žuta
};

const visibleCategories = ['Errors', 'Contrast Errors', 'Alerts'];

// Simple translation function
const t = (k) => (window.accessI18n?.[k] ?? k);

export default function RenderPdfSummary({
  results,
  totalScannedElements
}) {
  if (!results || Object.keys(results).length === 0) return null;

  const totalIssues = Object.values(results)
    .filter(cat => visibleCategories.includes(cat.description))
    .reduce((acc, cat) => acc + (cat.count || 0), 0);

  return (
    <div className="mb-5 pdf-avoid-break">
      <h3 className="mb-3">{t('Summary')}</h3>

      <p className="mb-2">
        {t('We scanned')} <strong>{totalScannedElements}</strong> {t('elements on this page.')}
        {t('We found')} <strong>{totalIssues}</strong> {t('accessibility issues.')}
      </p>

      <h4 className="fw-semibold mt-4 mb-1 fs-6">{t('Issues detected by category:')}</h4>
      <ul className="list-unstyled mb-3">
        {Object.entries(results)
          .filter(([_, cat]) => visibleCategories.includes(cat.description))
          .map(([key, category]) => {
            const color = categoryColors[category.description] || '#000';
            return (
              <li key={key} className="mb-1 d-flex align-items-center">
                <span
                  style={{
                    display: 'inline-block',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    marginRight: '8px'
                  }}
                ></span>
                <strong>{category.description}:</strong>&nbsp;{category.count}
              </li>
            );
          })}
      </ul>

      <hr className="my-3" />

      <p className="mt-2 mb-0 small text-muted">
        <span style={{ color: '#dc3545' }}>●</span> {t('Errors')} &nbsp;&nbsp;
        <span style={{ color: '#0d6efd' }}>●</span> {t('Contrast Errors')} &nbsp;&nbsp;
        <span style={{ color: '#ffc107' }}>●</span> {t('Alerts')}
      </p>
    </div>
  );
}
